import { TrackingUtil } from '../utils/tracking';
import { FormView } from '../account/form-view';
import { LinkUtil } from "../utils/link";
import firebase from "firebase/app"
import "firebase/auth";
import { UrlUtil } from "../utils/url-util"
import Cookies from 'js-cookie';
import "firebase/auth";
import constants from '../utils/constants';

export default FormView.extend({

    initialize: function(opts) {
        FormView.prototype.initialize.apply(this, [opts]);
        let queryRedirectUrl = opts.redirectUrl || UrlUtil.queryString("redirect");
        this.redirectUrl = queryRedirectUrl ? decodeURIComponent(queryRedirectUrl) : "/User/Settings/";
    },

    executeOperation: function() {
        let email = this.el.querySelector("#email");
        let passwd = this.el.querySelector("#passwd");
        return new Promise((resolve, reject) => {
            firebase.auth()
                .signInWithEmailAndPassword(email.value, passwd.value)
                .then(() => TrackingUtil.throwUserAuthenticationEvent('logIn', 'EMAIL'))
                .then(() => {
                    Cookies.set(constants.COOKIE_IS_REGISTERED, 
                        "true", { expires: 365, secure: true });
                    LinkUtil.goToUrl(this.redirectUrl);
                })
                .catch((error) => {
                    switch (error.code) {
                        case 'auth/wrong-password':
                            reject(getI18N(jlocale.wrongpassword));
                            break;
                        case 'auth/user-not-found':
                            reject(getI18N(jlocale.userNotFound));
                            break;
                        default:
                            reject(getI18N(jlocale.error));
                            break;
                    }
                });
        });
    }
});
